import { Component } from '@angular/core';

@Component({
  selector: 'ng2-map-app',
  template: require('./app.html'),
})
export class AppComponent {
  public center = 'Brampton, Canada';
  public positions = [ ];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/app.component.ts